export default function Newspaper() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.25 12V5.75C16.25 4.64543 15.3546 3.75 14.25 3.75H4.75C3.64543 3.75 2.75 4.64543 2.75 5.75V17.75C2.75 19.1307 3.86929 20.25 5.25 20.25H18.5M16.25 12V17.75C16.25 19.1307 17.3693 20.25 18.75 20.25C20.1307 20.25 21.25 19.1307 21.25 17.75V14C21.25 12.8954 20.3546 12 19.25 12H16.25ZM6.75 15.75H12.25M6.75 7.75H12.25V12.25H6.75V7.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
